import iconDark from '../../../../../../assets/fwupdate_dark.svg?react';

import AdminList from '../../../../../../components/updatejobs/AdminList';
import AdminCreate from '../../../../../../components/updatejobs/AdminCreate';
import {READ_JOB, CREATE_JOB} from '../../../../../../components/updatejobs/consts';
import {isRafiDeviceStockAssetGroup} from '../../routeHelper';
import AdminDetail from '../../../../../../components/updatejobs/AdminDetail';
import {ContextInfoProps, RouteConfig} from '@deviceinsight/ng-ui-scale-lib/api';

const createRoute = {
	relativePath: 'create',
	label: {
		id: 'assetgroup.detail.updatejobs.create.title',
		defaultValue: 'Create firmware updates'
	},
	component: AdminCreate,
	requiredAuthorities: [CREATE_JOB]
} satisfies RouteConfig;

const detailsRoute = {
	relativePath: ':id',
	label: {
		id: 'assetgroup.detail.updatejob.title',
		defaultValue: 'Firmware Update'
	},
	component: AdminDetail,
	requiredAuthorities: [READ_JOB]
} satisfies RouteConfig;

export default {
	relativePath: 'updatejobs',
	label: {
		id: 'assetgroup.detail.updatejobs.title',
		defaultValue: 'Update Jobs'
	},
	component: AdminList,
	iconSvg: iconDark,
	childRoutes: [createRoute, detailsRoute],
	requiredAuthorities: [READ_JOB],
	config: {
		onlyWithAssetGroupDefinition: 'Inventory'
	},
	show: (context: ContextInfoProps['contextInfo'] | null | undefined) => !isRafiDeviceStockAssetGroup(context)
} satisfies RouteConfig;
